import React from "react";

function VerifiedSheild() {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 20.75C8.75 20.75 16.75 16.75 16.75 10.75V3.75L8.75 0.75L0.75 3.75V10.75C0.75 16.75 8.75 20.75 8.75 20.75Z"
        stroke="#4072C8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default VerifiedSheild;
